// Reconstructed from production code; original paths and local names were not available.
import { MEDIA_BASE_URL } from "../services/config.js";
const videoExtension = /\.(?:mp4|webm|ogg|ogv|mov|m4v|avi)(?:$|[?#])/i;
function isVideo(l, i = "") {
  return String(i).toLowerCase().startsWith("video")
    ? true
    : videoExtension.test(String(l || ""));
}
function mediaUrl(l) {
  return l ? (l.startsWith("http") ? l : `${MEDIA_BASE_URL}${l}`) : "";
}
function productImage(l) {
  return (
    l?.image_url ||
    l?.main_image_url ||
    (l?.images && l.images[0]?.image_url) ||
    ""
  );
}
export { videoExtension, isVideo, mediaUrl, productImage };
